import { fokaAxios } from 'app/fokaAxios'
import { upload } from 'api/axios/tenth'

export default {
  getDocuments: ({ page, size }) =>
    fokaAxios.get('/api/v2/biz-channels/review-documents', {
      params: {
        page,
        limit: size,
      },
    }),
  addDocument: ({ channelId, documents }) =>
    fokaAxios.post(
      `/api/v2/biz-channels/${channelId}/review-documents`,
      documents
    ),
  uploadDocumentFiles: files =>
    Promise.all(
      files.map(file =>
        upload('/api/v2/files/private-upload-url', file, {
          type: 'DOCUMENT',
          filename: file.name,
        })
      )
    ),
  getDocumentsCount: () =>
    fokaAxios.get('/api/v2/biz-channels/review-documents/count'),
  deleteDocument: reviewDocumentId =>
    fokaAxios.delete(
      `/api/v2/biz-channels/review-documents/${reviewDocumentId}`
    ),
}
